import { CrudFilters } from "../../../../../hooks/useCrudFilters";
import { useTranslation } from "react-i18next";
import { Form, Button } from "react-bootstrap";
import { TruckLicencePlateSelectField } from "../commons/TruckLicencePlateSelectField";
import { ReactSelectOptionType } from "../../../../../shared/types/reactSelectType";
import {
  TableFilters,
  TableFiltersWrapper,
} from "../../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFilterInputWrapper } from "../../../../general/table/modules/commons/tableFilters/tableFilters";

export const TruckTableFilters = ({
  updateFilter,
  removeFilter,
  getFilter,
  filters,
  resetFilters,
}: CrudFilters) => {
  const { t } = useTranslation("common");

  const licencesValue = getFilter("licence", "in") as string;
  const titleSearchValue = getFilter("title", "contains") as string;
  const capacitySearchValue = getFilter("capacity", "in") as string;
  // const nameSearchValue = getFilter('driver.name', 'contains') as string;
  // const usernameSearchValue = getFilter('driver.username', 'contains') as string;

  return (
    <TableFiltersWrapper>
      <TableFilters>
        <TableFilterInputWrapper md={4}>
          <label>{t("Licence plates")}</label>
          <TruckLicencePlateSelectField
            onChange={(options: unknown) => {
              const selectedOptions = options as ReactSelectOptionType[];

              if (options === null || selectedOptions.length === 0) {
                removeFilter("licence");
                return;
              }

              const selectedOptionsStringArray = selectedOptions.map(
                (option) => {
                  return option.label.replace(/-/g, "").toUpperCase();
                },
              );

              updateFilter("licence", selectedOptionsStringArray, "in");
            }}
            value={licencesValue}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={4}>
          <label>{t("Title")}</label>
          <Form.Control
            type="text"
            placeholder={t("Title")}
            value={titleSearchValue ?? ""}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("title");
              } else {
                updateFilter("title", value, "contains");
              }
            }}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={4}>
          <label>{t("Capacity")}</label>
          <Form.Control
            type="number"
            placeholder={t("Capacity")}
            value={capacitySearchValue ?? ""}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("capacity");
              } else {
                updateFilter("capacity", Number(value), "in");
              }
            }}
          />
        </TableFilterInputWrapper>
      </TableFilters>

      {/*<Col md={3}>*/}
      {/*    <Form.Group>*/}
      {/*        <Form.Label>{t("Driver")}</Form.Label>*/}
      {/*        <Form.Control*/}
      {/*            type="text"*/}
      {/*            placeholder={t("Driver")}*/}
      {/*            value={usernameSearchValue ?? nameSearchValue ?? ''}*/}
      {/*            onChange={(event) => {*/}
      {/*                const value = event.target.value;*/}
      {/*                if (value === "") {*/}
      {/*                    removeFilter('driver.username');*/}
      {/*                    removeFilter('driver.name');*/}
      {/*                } else {*/}
      {/*                    updateFilter('driver.username', value, 'contains', undefined, 'or');*/}
      {/*                    updateFilter('driver.name', value, 'contains', undefined, 'or');*/}
      {/*                }*/}
      {/*            }}*/}
      {/*        />*/}
      {/*    </Form.Group>*/}
      {/*</Col>*/}

      {filters?.fields && Object.keys(filters.fields).length > 0 && (
        <Button
          onClick={resetFilters}
          size={"sm"}
          className="reset-filters"
          variant="light"
        >
          {t("Reset filters")}
        </Button>
      )}
    </TableFiltersWrapper>
  );
};
